module.exports = __webpack_public_path__ + "static/img/3.9397225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/3.png
// module id = TtkV
// module chunks = 0